export default __webpack_public_path__ + "static/media/mobile.9246c6ba.svg";